import { DELETE_USER, DELETE_USER_SUCCESSFUL, DELETE_USER_FAILED } from './actionTypes';

const initialState = {
    deleteUserError: null, deleteUsermessage: null, loadingDeleteUser: false
}

const deleteAccount = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_USER:
            state = {
                ...state,
                loadingDeleteUser: true,
                deleteUserError: null
            }
            break;
        case DELETE_USER_SUCCESSFUL:
            state = {
                ...state,
                loadingDeleteUser: false,
                deleteUsermessage: action.payload,
                deleteUserError: null
            }
            break;
        case DELETE_USER_FAILED:
            state = {
                ...state,
                deleteUsermessage: null,
                loadingDeleteUser: false,
                deleteUserError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default deleteAccount;